export default __webpack_public_path__ + "static/media/Mark-4-HUD-Radar.c75de1e1.jpg";